import { moment, numberToCurrency, isNumeric } from 'larasnap/support';
import get from 'lodash-es/get';

export default (instance, table, index) => {
    let column = {};

    Object.keys(instance.$props).forEach(prop => {
        column[prop] = instance[prop];
    });

    if (!column.name) {
        if (column.field) {
            column.name = `${column.field}-${index}`;
        } else if (column.label) {
            column.name = `${column.label}-${index}`;
        } else {
            column.name = `column-${index}`;
        }
    }

    if (typeof column.width === 'number') {
        column.width = `${column.width}px`;
    }
    if (!table.sortable) {
        column.sortable = false;
    }

    column.rowTemplate = instance.$scopedSlots.row;
    column.columnTemplate = instance.$scopedSlots.column;

    const getValue = data => (column.field ? get(data, column.field) : null);

    const getDisplayValue = rawData => {
        const value = getValue(rawData);

        if (column.display) {
            return column.display(rawData, value);
        } else if (value && column.displayType === 'currency') {
            return numberToCurrency(value);
        } else if (column.displayType === 'yes-no') {
            return value ? 'Yes' : 'No';
        } else if (column.dataType === 'date') {
            return moment(value).format(column.dateFormat);
        } else if (column.dataType === 'datetime') {
            return moment(value).format(column.datetimeFormat);
        } else {
            return value;
        }
    };

    const getSortValue = (rawData, displayData) => {
        const value = getValue(rawData);

        if (column.sortBy) {
            return column.sortBy(rawData, value);
        } else if (['date', 'datetime'].includes(column.dataType)) {
            return moment(value).valueOf();
        } else if (column.dataType === 'time') {
            return moment.time(value).valueOf();
        } else if (column.display) {
            return displayData[column.name];
        } else if (
            column.dataType === 'number' ||
            (column.dataType !== 'string' && isNumeric(value))
        ) {
            return Number(value);
        } else {
            return value;
        }
    };

    const getFilterValue = displayData => {
        return String(getValue(displayData)).toLowerCase();
    };

    const isSortable = () =>
        column.sortable && (column.field || column.display);

    return {
        ...column,
        getDisplayValue,
        getSortValue,
        getFilterValue,
        isSortable,
    };
};
